import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { PhoneVerifyConfirmationTemplate } from '../../templates/PhoneVerifyConfirmationTemplate'
import { ArrowLeft } from '@olxbr/olx-icons/dist/System'
import { breakpoints } from '../../../util/medias'

const Wrapper = styled.div`
  flex: 1;
  flex-direction: column;
  margin: auto;
  @media (max-width: ${breakpoints['mobile']}px) {
    margin-left: var(--spacing-2);
    margin-right: var(--spacing-2);
  }
  @media (min-width: 840px) {
    max-width: 600px;
  }
  @media (min-width: ${breakpoints['mobile'] + 1}px) and (max-width: ${breakpoints['tablet']}px) {
    width: 80vw;
  }
`

const StyledArrow = styled(ArrowLeft)`
  color: var(--color-neutral-130);
`
const ArrowContainer = styled.div`
  cursor: pointer;
  margin-bottom: var(--spacing-4);

  ${({ modalMode }) => modalMode && `margin-bottom: var(--spacing-2);`}
`

const PhoneVerifyConfirmationPage = ({
  onPhoneVerifyConfirmationSuccess,
  onBackClick,
  phone,
  token,
  abTests,
  modalMode,
}) => (
  <Wrapper>
    <ArrowContainer onClick={onBackClick} modalMode={modalMode}>
      <StyledArrow />
    </ArrowContainer>
    {!modalMode && <span className="typo-title-large mb-4">Já tenho um código</span>}
    {modalMode && <span className="typo-title-medium mb-1">Já tenho um código</span>}
    <PhoneVerifyConfirmationTemplate
      phone={phone}
      onBackClick={onBackClick}
      onPhoneVerifySubmit={onPhoneVerifyConfirmationSuccess}
      token={token}
      abTests={abTests}
      modalMode={modalMode}
    />
  </Wrapper>
)

PhoneVerifyConfirmationPage.propTypes = {
  onPhoneVerifyConfirmationSuccess: PropTypes.func,
  onBackClick: PropTypes.func,
  phone: PropTypes.string,
  token: PropTypes.string,
  abTests: PropTypes.string,
  modalMode: PropTypes.bool,
}

export { PhoneVerifyConfirmationPage }
